import React, { useRef, useState, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
//import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import DescriptionOutlinedIcon  from '@mui/icons-material/Description';
import { BlobServiceClient } from '@azure/storage-blob';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Tag } from 'primereact/tag';
import ls from 'localstorage-slim';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import { Button as PrimeReactButton } from 'primereact/button';
import 'primeicons/primeicons.css';
import uploadIcon from '../../src/assets/upload-icon.svg';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Dialog } from 'primereact/dialog';
import LinearProgress from '@mui/material/LinearProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTheme } from '@mui/material/styles';
import './DataLoader.css';

import {
    Container,
    Stack,
    Typography,
    Card
  } from '@mui/material';
import { Padding } from '@mui/icons-material';




export default function DataLoader() {
    const theme = useTheme();
    var [userName, setUserName] = React.useState('');
    // setUserName('tluser')

    const sasToken = process.env.REACT_APP_STORAGE_SAS_KEY


    const containerName = process.env.REACT_APP_DATA_LOADER_CONTAINER;
    const storage_account = process.env.REACT_APP_STORAGE_ACCOUNT || ""

    const blobServiceClient = new BlobServiceClient(`https://${storage_account}.blob.core.windows.net?${sasToken}`);
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const [totalSize, setTotalSize] = useState(0);
    const [indexingData, setIndexingData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [indexingStatusVisible, setIndexingStatusVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [fileToDelete, setFileToDelete] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);


    const toast = useRef(null);
    const [indexingStatusQueryItems, setIndexingStatusQueryItems] = useState([]);
    var project_index_mapping = null
    const [open, setOpen] = React.useState(false);
    const request_body_template = {
        "Project": "pmr-test",
        "skipblobs": "false",
        "TENANT_ID": process.env.REACT_APP_TENANT_ID,
        "SEARCH_SERVICE": process.env.REACT_APP_SEARCH_SERVICE,
        "SEARCH_KEY": process.env.REACT_APP_SEARCH_KEY,
        "STORAGE_KEY": process.env.REACT_APP_STORAGE_KEY,
        "OUTPUT_STORAGE_KEY": process.env.REACT_APP_STORAGE_KEY,
        "output_storage_account": process.env.REACT_APP_STORAGE_ACCOUNT || "",
        "FORM_RECOGN_SERVICE": "",
        "FORM_RECOG_KEY": "",
        "remove": "false",
        "removeall": "false",
        "localpdfparser": "true",
        "output_container": "content",
        "default_parser": "false",
        "index_approach": "hyde"

    }
    var projlist = []
    var [project, setProject] = React.useState('');
    var [projectIndex, setProjectIndex] = React.useState('');
    var [disableURLSubmit, setDisableURLSubmit] = React.useState(true);
    var [indexCompleteCount, setIndexCompleteCount] = React.useState(0)
    var [indexFailCount, setIndexFailCount] = React.useState(0)
    var [indexRunningCount, setIndexRunningCount] = React.useState(0)
    var [projectsDetails, setProjectsDetails] = React.useState([]);
    var query_urls = []
    var jsonString = {}
    var input_url = ''
    var show_response_detail = 0
    var index_status = ''
    var status_query_url = ''
    const vertical = 'bottom';
    const horizontal = 'center';
    var projectmenulist = []
    var [inputURL, setInputURL] = React.useState('');

    const HandleInputChange = (e) => {
        setInputURL(e.target.value)
        show_response_detail = 0
        input_url = e.target.value
        if (input_url.length > 0) {
            setDisableURLSubmit(false)
        }
        else {
            setDisableURLSubmit(true)
        }
        // console.log(input_url)
    };

    const classifySource = () => {
        setIndexCompleteCount(0)
        setIndexFailCount(0)
        setIndexRunningCount(0)
        var inputValue = inputURL
        var request_body = {}

        if (inputValue.toString().includes("//github.com/")) {
            // const url = 'https://github.com/Tavant-AIA/Knowledge-AI/tree/gpt_app_v2'
            const branch = inputValue.substring(inputValue.indexOf("/tree/") + 6);
            var organization_url = inputValue.substring(inputValue.indexOf("://") + 3, inputValue.indexOf('/tree/'));
            organization_url = organization_url.substring(0, organization_url.lastIndexOf('/'))
            const organization = organization_url.substring(organization_url.indexOf('/') + 1);
            const storage_account = process.env.REACT_APP_STORAGE_ACCOUNT || ""
            const additional_reqbody_info = {
                "storage_account": storage_account,
                "input_container": "ci-audio-diarized",
                "output_container": "content",
                "repo_type": "github",
                "personal_access_token": "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",
                "branch": branch,
                "organization": organization,
                "organization_url": organization_url,
                "SEARCH_INDEX": projectIndex
            }

            request_body = { ...request_body_template, ...additional_reqbody_info }
            jsonString = JSON.stringify(request_body, null, 2);
            indexDocs(jsonString)
        }

        else if (inputValue.toString().includes(".blob.core.windows.net")) {
            var input_container = inputValue.substring(inputValue.indexOf(".blob.core.windows.net") + (".blob.core.windows.net").length + 1)
            input_container = input_container.substring(0, input_container.indexOf('/'))
            const storage_account = inputValue.substring(inputValue.indexOf('://') + 3, inputValue.indexOf('.blob.core.windows.net'))
            var input_container = inputValue.substring(inputValue.indexOf('.blob.core.windows.net') + (".blob.core.windows.net").length + 1)
            // console.log('inp_cont :', input_container)
            input_container = input_container.substring(0, input_container.indexOf('/'))
            const additional_reqbody_info = {
                "storage_account": storage_account,
                "input_container": input_container,
                "output_container": "content",
                "repo_type": "blob",
                "SEARCH_INDEX": projectIndex
            }

            request_body = { ...request_body_template, ...additional_reqbody_info }
            jsonString = JSON.stringify(request_body, null, 2);
            indexDocs(jsonString)
        }

        else if (inputValue.toString().includes("//dev.azure.com/")) {
            // const url = 'https://dev.azure.com/Cincinnati-TMAP/'
            var organization_url = inputValue.substring(0, (inputValue.indexOf('dev.azure.com/') + ('dev.azure.com').length) + 1);
            var organization = inputValue.substring((inputValue.indexOf('dev.azure.com/') + ('dev.azure.com').length) + 1);
            // console.log('org=', organization)
            organization = organization.substring(0, organization.indexOf('/'))
            organization_url = organization_url + organization
            const storage_account = process.env.REACT_APP_STORAGE_ACCOUNT || ""
            const additional_reqbody_info = {
                "storage_account": storage_account,
                "input_container": "ci-audio-diarized",
                "output_container": "content",
                "repo_type": "azuredevops",
                "organization_url": organization_url,
                "organization": organization,
                "SEARCH_INDEX": projectIndex
            }

            request_body = { ...request_body_template, ...additional_reqbody_info }
            jsonString = JSON.stringify(request_body, null, 2);
            indexDocs(jsonString)
        }
        else if (inputValue.toString().includes("www.youtube.com/")) {
            const reqbody_info = {
                "url": inputValue,
                "SEARCH_INDEX": projectIndex
            }

            // request_body = { ...request_body_template, ...additional_reqbody_info }
            jsonString = JSON.stringify(reqbody_info, null, 2);
            indexDocs(jsonString)
        }
        else {
            request_body = {}
            toast.current.show({ severity: 'warn', summary: 'Unsupported/Unidentified Source !', detail: 'Supported sources : [ GitHub, Azure Blob, Azure Devops, Youtube ]', life: 5000 });
        }

        jsonString = JSON.stringify(request_body, null, 2);
        // indexDocs(jsonString)
    };

    const indexDocs = async (jsonstr) => {
        toast.current.show({ severity: 'info', summary: 'Starting Document Indexing ...', detail: '' });
        show_response_detail = 0
        const index_url = process.env.REACT_APP_INDEX_URL || ""
        await fetch(
            index_url, {
            method: 'POST',
            body: jsonstr,
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then((response) => {
                if (response.status == 200 || response.status == 202) {
                }
                else {
                    toast.current.show({ severity: 'warning', summary: 'Exception occurred while indexing some document(s) ...', detail: 'document' });
                }
                index_status = 1
                return response.json()
            })
            .then(data => {
                status_query_url = data.statusQueryGetUri;
                query_urls.push(status_query_url)
                setIndexingStatusQueryItems(query_urls)
                // console.log('status url : ', status_query_url);
            })
            .catch((err) => {
                console.log(err.message);
                index_status = 0
            });
        // console.log("QUERY URLS : ", indexingStatusQueryItems)
    };

    const indexingStatus = async () => {
        setIndexingStatusVisible(true)
        setIsLoading(true);
        try {
            const index_info_url = process.env.REACT_APP_INDEX_INFO_URL || ""
            const response = await axios.post(
                index_info_url,
                { index_name: projectIndex } 
            );
            const data = response.data;

            setIndexingData(data);
            setIsModalOpen(true);
        } catch (error) {
            console.error('Error fetching indexing status', error);
        }
        finally {
            setIsLoading(false);
        }
    };
    const queryStatus = async () => {
        show_response_detail = 1
        // console.log('QUERYURLS = ',query_urls)
        for (let i = 0; i < indexingStatusQueryItems.length; i++) {
            query_urls = indexingStatusQueryItems
            await fetch(query_urls[i], {
                method: 'GET',
            })
                .then((response) => {
                    return response.json()
                })
                .then((data) => {
                    // console.log('RTS :',data.runtimeStatus)
                    if (data.runtimeStatus == 'Completed') {
                        setIndexCompleteCount(indexCompleteCount + 1)
                        if (indexRunningCount > 0) {
                            // console.log('running count = ', indexRunningCount)
                            setIndexRunningCount(indexRunningCount - 1)
                            // console.log('run finished')
                            // console.log('running count = ', indexRunningCount)
                        }
                        // console.log('POPPING QUERYURL')
                        query_urls.pop(i)
                        setIndexingStatusQueryItems(query_urls)
                        // setQueryURLS(query_urls)
                        
                    }
                    else if (data.runtimeStatus == 'Failed') {
                        setIndexFailCount(indexFailCount + 1)
                        query_urls.pop(i)
                        // setQueryURLS(query_urls)
                    }
                    else if (data.runtimeStatus == 'Running') {
                        // console.log('Logging Run status')
                        setIndexRunningCount(1)
                    }
                })
                .catch((err) => {
                    console.log(err.message);
                    index_status = 'Failed'
                });

        }
        if (query_urls.length == 0) {
            if (indexFailCount > 0) {
                toast.current.show({ severity: 'warning', summary: 'Exception occurred !', detail: 'Some document(s) could not be indexed' });
            }
            else {
                toast.current.show({ severity: 'success', summary: 'Success !', detail: 'Indexing document(s) Complete' });
            }
            // console.log(indexCompleteCount,' || ', indexFailCount,' || ', indexRunningCount)
        }
        else {
            if (indexRunningCount > 0) {
                toast.current.show({ severity: 'info', summary: 'Indexing ... !', detail: 'Document(s) are being indexed' })
            }
        }
        // setOpen(true);
    };


    const handleFileUpload = async (e) => {
        var timestamp = Date.now();
      
        var folder_name = userName + '/' + project + '/' + timestamp

        show_response_detail = 0
        const files = e.files;
        // console.log(e)
        if (files.length === 0) {
            console.log('No files selected.');
            setDisableURLSubmit(false)
            return;
        }
        setDisableURLSubmit(true)
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // console.log('FILE : ', file)
            var blobName = file.name;
            blobName = folder_name + '/' + blobName
            // console.log('blob name : ', blobName)
            const blockBlobClient = containerClient.getBlockBlobClient(blobName);

            try {
                await blockBlobClient.uploadData(file);
                // console.log(`File ${file.name} uploaded successfully.`);
                const storage_account = process.env.REACT_APP_STORAGE_ACCOUNT || ""
                const additional_reqbody_info = {
                    "storage_account": storage_account,
                    "input_container": "pmr-index",
                    "output_container": "content",
                    "repo_type": "blob",
                    "index_approach":"hyde",
                    "path": folder_name,
                    "SEARCH_INDEX": projectIndex
                }

                const request_body = { ...request_body_template, ...additional_reqbody_info }
                const jsonString = JSON.stringify(request_body, null, 2);
                // console.log('JSON STRING : ', jsonString)
                indexDocs(jsonString);



                // Call function with the container details to index docs
            } catch (error) {
                console.error('Error uploading file:', error);
            }
        }
    };
    const onTemplateRemove = (file, callback) => {
        setTotalSize(totalSize - file.size);
        callback();
    }
    const itemTemplate = (file, props) => {
        return (
            <>
                <div style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>{file.name}</span>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <Tag value={props.formatSize} severity="info" className="px-3 py-2" />
                </div>
                <span><PrimeReactButton type="button" icon="pi pi-trash" className="p-button p-component p-button-icon-only p-button-text p-button-rounded p-button-danger ml-auto" onClick={() => onTemplateRemove(file, props.onRemove)} /></span>

            </>
        );
    };


    useEffect(() => {
        setIndexingStatusQueryItems([])
        setIndexCompleteCount(0)
        setIndexFailCount(0)
        setIndexRunningCount(0)
        setLoading(false);
        const user_data = ls.get('token-gpt-app');
       

        if (user_data && user_data['email']) {
            var uname = user_data['email'].split('@')[0];
            setUserName(uname);

            // Comment below statement after testing
            // uname = 'tluser'

            fetch((process.env.REACT_APP_PROJECT_INFO_URL || ''), {
                method: 'POST',
                body: JSON.stringify({ "user": uname })
            })
                .then((response) => {
                    // console.log('Projects Response : ', response)
                    return response.json();
                })
                .then(data => {
                    // Use the data from the response
                    project_index_mapping = data.reduce((acc, item) => {
                        // Extract "ProjectName" and "IndexName" from each item
                        const { ProjectName, IndexName } = item;

                        // Create the key-value pair in the accumulator
                        acc[ProjectName] = IndexName;

                        return acc;
                    }, {});
                    // console.log('project index mapping : ', project_index_mapping)
                    projlist = Object.keys(project_index_mapping)
                    // console.log('KEYS in project index mapping : ', projlist)


                    projectmenulist = Object.entries(project_index_mapping).map(([key, value]) => ({
                        label: key,
                        value: value,
                    }));
                    // console.log('projindmap : ', projectmenulist)
                    setProjectsDetails(projectmenulist)
                    // console.log('VALUES in project index mapping : ', Object.values(project_index_mapping))
                })
                .catch((err) => {
                    console.log(err.message);
                });
        }
    }, []);


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setIsModalOpen(false);
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );


    const handleProjectSelection = (event) => {
        setProject(event.target.value)
        const selectedItem = projectsDetails.find((item) => item.label === event.target.value);
        if (selectedItem) {
            setProjectIndex(selectedItem.value);
        }
    }

    const handleDeleteClick = (rowData) => {
        setFileToDelete(rowData);
        setDeleteDialogVisible(true);
    };

    const confirmDeleteFile = async () => {
        if (!fileToDelete) return;

        setIsDeleting(true);
        try {
            const delete_url = process.env.REACT_APP_DELETE_SEARCH_VECTORS_URL || "";
            const response = await axios.post(
                delete_url,
                {
                    sourcefile: fileToDelete.source_blob,
                    index_name: projectIndex,
                    dry_run: false
                }
            );

            if (response.data.success) {
                toast.current.show({ 
                    severity: 'success', 
                    summary: 'Success', 
                    detail: `Deleted ${response.data.deleted_count} chunks from "${fileToDelete.source_blob}"` 
                });
                
                // Refresh the indexing status to update the table
                await indexingStatus();
            } else {
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Delete Failed', 
                    detail: response.data.message || 'Failed to delete file chunks' 
                });
            }
        } catch (error) {
            console.error('Error deleting file:', error);
            toast.current.show({ 
                severity: 'error', 
                summary: 'Error', 
                detail: 'Failed to delete file chunks from search index' 
            });
        } finally {
            setIsDeleting(false);
            setDeleteDialogVisible(false);
            setFileToDelete(null);
        }
    };

    const cancelDelete = () => {
        setDeleteDialogVisible(false);
        setFileToDelete(null);
    };
    const statusBodyTemplate = (rowData) => {
        let icon = '';
        let color = '';

        switch (rowData.status) {
            case 'failed':
                icon = 'pi pi-times-circle';
                color = 'red';
                break;
            case 'success':
                icon = 'pi pi-check-circle';
                color = 'green';
                break;
            case 'exception':
                icon = 'pi pi-exclamation-triangle';
                color = 'orange';
                break;
            default:
                break;
        }

        return (
            <span style={{ color }}>
                <i className={icon} style={{ marginRight: '.5rem' }}></i>
                {rowData.status}
            </span>
        );
    };

    return (
        <Container maxWidth="lg" sx={{ mx: 'auto' }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4} mt={4}>
            <Typography variant="h4" gutterBottom
            sx={{
                color: theme.palette.mode === 'dark' ? '#C7C9C7' : '#333f48',
              }}>
              Data Loader
            </Typography>

          </Stack>
          <Card sx={{ mx: 'auto', maxWidth: '100%' }}>
          <div className="data-loader-root">
            <Toast ref={toast} />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '20px'}}>
                {/* {getProjectsList('tluser')} */}
                <FormControl sx={{ m: 2, minWidth: 500 }}>
                    <InputLabel id="demo-simple-select-label" className='font-medium'>Select Project</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={project}
                        label="Select Project"
                        onChange={handleProjectSelection}
                        className='font-medium'
                    >
                        {projectsDetails.map((item) => (
                            <MenuItem key={item.label} value={item.label}>
                                {item.label}
                            </MenuItem>
                        ))}

                    </Select>

                </FormControl>
                <Button 
        onClick={indexingStatus} 
        startIcon={<DescriptionOutlinedIcon />}
        disabled={!project} 
    >
        Check Indexing Status
    </Button>

                {/* <p>{project} || {projectIndex}</p> */}
            </div>
            {project ?
                (<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{ width: '100%', maxWidth: '700px' }}>
                        <FileUpload name="data files" multiple maxFileSize={29000000} accept=".PDF, .DOCX, .DOC, .TXT, .MP4" uploadLabel="Index File(s)"
                            emptyTemplate={
                                <div className="drop-zone mb-3">
                                    <img src={uploadIcon} alt="upload-file" />
                                    <p>Drag and Drop, or click to Choose.</p>
                                    <p className='file-format'>PDF, DOCX, TXT, MP4 files up to 30MB allowed</p>
                                </div>
                            }
                            customUpload uploadHandler={handleFileUpload} itemTemplate={itemTemplate} 
                           
                            />
                    </div>


                    <br />
                    <div style={{ textAlign: 'center' }}>OR</div>
                    <br />
                    <div style={{ width: '100%', maxWidth: '700px' }}>
                        <TextField fullWidth id="outlined-basic" label="Source File URL" variant="outlined" onChange={HandleInputChange} />

                        <br /><br /><Button variant="outlined" endIcon={<SendIcon />} onClick={classifySource} disabled={disableURLSubmit}>Submit URL</Button>

                    </div>
                    <div style={{ paddingBottom: '5%' }}>
                        <Snackbar
                            open={open}
                            autoHideDuration={3000}
                            onClose={handleClose}
                            message={`Completed: ${indexCompleteCount}  ,   Failed: ${indexFailCount}   ,   Running: ${indexRunningCount}`}
                            action={action}
                            anchorOrigin={{ vertical, horizontal }}

                        />

                    </div>
                    {isModalOpen && (
                         <Dialog header="Indexing File Status" visible={indexingStatusVisible} style={{ width: '75vw', marginTop:'75px' }}
                         modal contentStyle={{ height: '580px' }} onHide={() => setIndexingStatusVisible(false)} >
                     
                        <div className="table-header">
                        <Button variant="contained" className="primary-btn" onClick={indexingStatus} startIcon={<RefreshIcon /> }>Refresh
                        </Button>

                        <IconField iconPosition="left"style={{ marginBottom: '1rem' }} >
                            <InputIcon className="pi pi-search" />
                            <InputText onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search by name" />
                        </IconField>
                    </div>
                <div className="card">
                {isLoading && <LinearProgress />} 

                    <DataTable
                    loader 
                        value={indexingData}
                        stripedRows
                        paginator
                        tableStyle={{ minWidth: '50rem' }}
                        rows={5}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        loading={loading}
                        globalFilter={globalFilter}
                        emptyMessage="No document found."
                    >
                        
                      
                        <Column
                            field="source_blob"
                            header="File Name"
                            sortable
                            style={{ width: '25rem', wordBreak: 'break-all', overflowWrap: 'break-word', whiteSpace: 'normal'  }}
                        />   
                        
                        <Column
                            field="process_status"
                            header="Status Description"
                            sortable
                            style={{ width: '25rem', wordBreak: 'break-all', overflowWrap: 'break-word', whiteSpace: 'normal'  }}
                        />
                        <Column
                            field="created_date"
                            header="Created Date"
                            sortable
                            style={{ width: '25rem', wordBreak: 'break-all', overflowWrap: 'break-word', whiteSpace: 'normal'  }}
                        />
                        <Column
                            field="status"
                            header="Status"
                            body={statusBodyTemplate}
                            sortable
                            style={{ minWidth: '6rem' }}
                        />
                        <Column
                            header="Actions"
                            body={(rowData) => (
                                <PrimeReactButton
                                    type="button"
                                    icon="pi pi-trash"
                                    className="p-button p-component p-button-icon-only p-button-text p-button-rounded p-button-danger"
                                    onClick={() => handleDeleteClick(rowData)}
                                    tooltip="Delete file from search index"
                                    tooltipOptions={{ position: 'top' }}
                                />
                            )}
                            style={{ textAlign: 'center', width: '4rem' }} 
                        />

                    </DataTable>
                </div>
                
                {/* Delete Confirmation Dialog */}
                <Dialog
                    header="Confirm Delete"
                    visible={deleteDialogVisible}
                    style={{ width: '450px' }}
                    modal
                    onHide={cancelDelete}
                    footer={
                        <div>
                            <PrimeReactButton
                                label="Cancel"
                                icon="pi pi-times"
                                className="p-button-text"
                                onClick={cancelDelete}
                                disabled={isDeleting}
                            />
                            <PrimeReactButton
                                label="Delete"
                                icon="pi pi-trash"
                                className="p-button-danger"
                                onClick={confirmDeleteFile}
                                loading={isDeleting}
                                disabled={isDeleting}
                            />
                        </div>
                    }
                >
                    {fileToDelete && (
                        <div>
                            <p>Are you sure you want to delete all search index chunks for:</p>
                            <p style={{ fontWeight: 'bold', wordBreak: 'break-all', marginTop: '10px' }}>
                                {fileToDelete.source_blob}
                            </p>
                            <p style={{ marginTop: '10px', color: '#d32f2f' }}>
                                ⚠️ This action cannot be undone. All vectors/chunks associated with this file will be permanently removed from the search index.
                            </p>
                        </div>
                    )}
                </Dialog>
                
                </Dialog>
                  )}
                </div>
                ) : <div></div>}
        </div>
          </Card>
          </Container>
        
    )
}